function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "a",
  x1: 99.29,
  x2: 455.11,
  y1: 191.95,
  y2: 191.95,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  offset: 0.32,
  stopColor: "#5b67a6"
}), React.createElement("stop", {
  offset: 0.66,
  stopColor: "#816199"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#a65b8d"
})), React.createElement("linearGradient", {
  id: "b",
  x1: 110.35,
  x2: 461.25,
  y1: 368.96,
  y2: 368.96,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  offset: 0.32,
  stopColor: "#5b67a6"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#a65b8d"
})), React.createElement("linearGradient", {
  id: "c",
  x1: 56.89,
  x2: 203.89,
  y1: 207.32,
  y2: 207.32,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  offset: 0,
  stopColor: "#a65b8d"
}), React.createElement("stop", {
  offset: 0.31,
  stopColor: "#ff8c66"
}), React.createElement("stop", {
  offset: 0.72,
  stopColor: "#ffa98c"
})));

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fill: "url(#a)",
  d: "M455.11 204.62a156.11 156.11 0 0 1-69.88 130.3h-.06l-66.07-66.07-2.46-2.47v-.08a64.25 64.25 0 0 0 46.26-61.1c.32-35.65-29.62-64.81-65.26-64.81h-107L99.31 49.05v-.08h214.87a156.27 156.27 0 0 1 140.93 155.65z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  fill: "url(#b)",
  d: "M428.87 463.03L240.72 274.89h-49.16l-40.6 40.6L298.5 463.03h130.37z"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  fill: "url(#c)",
  d: "M104.19 107.62h-47.3l99.7 99.7-99.7 99.7h47.3l99.7-99.7-99.7-99.7z"
});

var SvgVectorized = function SvgVectorized(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgVectorized, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/vectorized.2ee12ca2.svg";
export { ForwardRef as ReactComponent };